import React from 'react'
import { Typography, CircularProgress, Tooltip } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { CoreIconButton } from 'src/components/core'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from '../style'

const VideoUploadProgress = ({ classes, upload, onCancel }) => {
  const getProgressInfo = () => {
    switch (upload.status) {
      case 'uploading':
        return {
          value: upload.progress || 0,
          color: '#015ffb',
          text: 'Uploading...',
          subtext: null,
          indeterminate: false,
        }
      case 'processing':
        return {
          value: upload.progress || 0,
          color: '#4caf50',
          text: 'Processing...',
          subtext: null,
          indeterminate: false,
        }
      case 'transcode_starting':
        return {
          value: 0,
          color: '#4caf50',
          text: 'Transcoding...',
          subtext: 'This may take a while.',
          indeterminate: true,
        }
      case 'transcoding':
        return {
          value: 0,
          color: '#4caf50',
          text: 'Transcoding...',
          subtext: 'This may take a while.',
          indeterminate: true,
        }
      default:
        return {
          value: 0,
          color: '#015ffb',
          text: 'Starting...',
          subtext: null,
          indeterminate: false,
        }
    }
  }
  const progressInfo = getProgressInfo()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div className={classes.bordersHolder}>
        <div
          className={classes.imageViewContainer}
          style={{
            backgroundColor: '#F4F6F8',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <div
            style={{
              display: 'flex',
              position: 'relative',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            <CircularProgress
              variant={
                progressInfo.indeterminate ? 'indeterminate' : 'determinate'
              }
              value={progressInfo.value}
              size={32}
              thickness={3}
              style={{ color: progressInfo.color }}
            />
            {!progressInfo.indeterminate && (
              <Typography
                style={{
                  fontSize: '9px',
                  color: '#666',
                  fontWeight: 500,
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                {Math.round(progressInfo.value)}%
              </Typography>
            )}
          </div>

          <div style={{ textAlign: 'center' }}>
            <Typography className={classes.subtitleAdditional}>
              {progressInfo.text}
            </Typography>
            {progressInfo.subtext && (
              <Typography
                className={classes.subtitleAdditional}
                style={{ fontSize: '10px', color: '#888', marginTop: '2px' }}
              >
                {progressInfo.subtext}
              </Typography>
            )}
          </div>
        </div>

        {upload.status === 'uploading' && (
          <CoreIconButton
            className={classes.deleteButton}
            color="white"
            variant="contained"
            size="small"
            onClick={() => onCancel(upload.id)}
          >
            <Icon icon="mdi:close" />
          </CoreIconButton>
        )}
      </div>

      <Tooltip title={<Typography>{upload.fileName || '-'}</Typography>}>
        <div
          className={classes.titleBar}
          style={{
            padding: '4px',
            cursor: 'pointer',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              width: '100%',
            }}
          >
            <Typography
              className={classes.title}
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                wordBreak: 'break-word',
                lineHeight: '1.4em',
                maxHeight: '2.4em',
                textAlign: 'center',
              }}
            >
              {upload.fileName || '-'}
            </Typography>
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

export default withStyles(styles)(VideoUploadProgress)
